import clsx from 'clsx'
import { TPopMessageItem } from './types'
import styles from './styles.module.scss'
import PopMessageIcon from './Icon'

const PopMessageItem = ({
  cta,
  id,
  message,
  onClose,
  size = 'md',
  title,
  variant = 'default',
}: TPopMessageItem) => {
  return (
    <article
      aria-atomic="true"
      aria-describedby={`New Notification: ${title}`}
      aria-live="assertive"
      className={clsx(styles.popMessage, styles[size])}
      key={id}
      onAnimationEnd={() => onClose(id)}
      role="alert"
    >
      <div className={styles.content}>
        <div className={styles.iconWrap}>
          <PopMessageIcon variant={variant} />
          <h2 className={clsx(styles.title, styles[variant], styles[size])}>{title}</h2>
        </div>
        {message && <p className={styles.message}>{message}</p>}
      </div>

      <div className={styles.cta}>{cta && cta}</div>

      <button className={styles.close} onClick={() => onClose(id)} type="button">
        <svg xmlns="http://www.w3.org/2000/svg" height="16" width="12" viewBox="0 0 384 512">
          <path d="M342.6 150.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L192 210.7 86.6 105.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L146.7 256 41.4 361.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L192 301.3 297.4 406.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L237.3 256 342.6 150.6z" />
        </svg>
      </button>

      <span className={styles.timer}>
        <span className={styles.progress}></span>
      </span>
    </article>
  )
}
export default PopMessageItem
